var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"400px"},attrs:{"id":"owe_map_border_compo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }